import { useDeepCompareEffect } from 'react-use';
import { useLazyCustomFields } from '../useLazyCustomFields/useLazyCustomFields';
/**
 * A hook for getting custom fields (attributes and their values) of an instance
 * of an entity.
 */
export const useCustomFields = (options) => {
    const [readCustomFields, result] = useLazyCustomFields();
    // Handles fetching custom fields data.
    useDeepCompareEffect(() => {
        readCustomFields(options);
    }, [options]);
    return result;
};
